(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lullor-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-cart-count')) {
    customElements.define('home-cart-count', class extends HTMLElement {
      connectedCallback() {
        this.refresh = async () => { try { const response = await fetch(this.dataset.url, { headers: { Accept: 'application/json' } }); if (response.ok) this.textContent = (await response.json()).item_count; } catch (error) {} };
        this.events = ['cart:updated', 'cart:update', 'cart-update', 'cartUpdate', 'lullor:cart-updated'];
        this.events.forEach((name) => document.addEventListener(name, this.refresh));
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          this.unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh);
        }
        this.onSubmit = (event) => { if (event.target.matches('form[action*="/cart/add"]')) { setTimeout(this.refresh, 500); setTimeout(this.refresh, 1500); } };
        document.addEventListener('submit', this.onSubmit, true);
        window.addEventListener('pageshow', this.refresh);
      }
      disconnectedCallback() { this.events?.forEach((name) => document.removeEventListener(name, this.refresh)); this.unsubscribeCartUpdate?.(); document.removeEventListener('submit', this.onSubmit, true); window.removeEventListener('pageshow', this.refresh); }
    });
  }
  const initHomeMenus = (scope = document) => scope.querySelectorAll('[data-hv4-menu]').forEach((menu) => {
    if (menu.dataset.ready) return;
    menu.dataset.ready = 'true';
    const summary = menu.querySelector('summary');
    const close = (restoreFocus = false) => { if (!menu.open) return; menu.removeAttribute('open'); if (restoreFocus) summary?.focus(); };
    summary?.addEventListener('pointerdown', () => { menu.dataset.keyboardOpen = 'false'; });
    summary?.addEventListener('keydown', (event) => { if (event.key === 'Enter' || event.key === ' ') menu.dataset.keyboardOpen = 'true'; });
    menu.addEventListener('toggle', () => {
      summary?.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
      if (menu.open && menu.dataset.keyboardOpen === 'true') requestAnimationFrame(() => menu.querySelector('nav a')?.focus());
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => close()));
    menu.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(true); });
    document.addEventListener('pointerdown', (event) => { if (!menu.contains(event.target)) close(); });
  });
  initHomeMenus();
  document.addEventListener('shopify:section:load', (event) => initHomeMenus(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lullor-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-hero')) {
    customElements.define('home-hero', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-go]')];
        this.index = 0;
        this.pointerInside = false;
        this.focusInside = false;
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.go))));
        this.addEventListener('mouseenter', () => { this.pointerInside = true; this.stop(); });
        this.addEventListener('mouseleave', () => { this.pointerInside = false; if (!this.focusInside) this.start(); });
        this.addEventListener('focusin', () => { this.focusInside = true; this.stop(); });
        this.addEventListener('focusout', (event) => {
          if (event.relatedTarget && this.contains(event.relatedTarget)) return;
          this.focusInside = false;
          if (!this.pointerInside) this.start();
        });
        this.start();
      }
      show(next) {
        if (!this.slides.length) return;
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => { const active = index === this.index; slide.hidden = !active; slide.classList.toggle('is-active', active); });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', index === this.index ? 'true' : 'false'));
      }
      start() { if (this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches) return; this.stop(); this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.delay) || 6000); }
      stop() { clearInterval(this.timer); }
      disconnectedCallback() { this.stop(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lullor-home-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-product-carousel')) {
    customElements.define('home-product-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-product-track]');
        this.controls = this.querySelector('[data-product-controls]');
        this.previous = this.querySelector('[data-product-previous]');
        this.next = this.querySelector('[data-product-next]');
        this.previous.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.onScroll = () => this.update();
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      move(direction) {
        const card = this.track.querySelector('.hv4-product-item');
        const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || this.track.clientWidth) + gap), behavior: 'smooth' });
      }
      update() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.controls.hidden = max <= 2;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      }
      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lullor-home-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-review-carousel')) {
    customElements.define('home-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        this.controls = this.querySelector('[data-review-controls]');
        this.cards = [...this.track.querySelectorAll('.hv4-review-card')];
        this.onScroll = () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.observer = new ResizeObserver(() => this.build());
        this.observer.observe(this.track);
        this.build();
      }
      build() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const firstLeft = this.cards[0]?.offsetLeft || 0;
        this.positions = this.cards
          .map((card) => Math.min(max, Math.max(0, card.offsetLeft - firstLeft)))
          .filter((position, index, positions) => index === 0 || Math.abs(position - positions[index - 1]) > 2);
        this.controls.replaceChildren();
        if (max <= 2 || this.positions.length < 2) {
          this.controls.hidden = true;
          return;
        }
        this.controls.hidden = false;
        this.positions.forEach((position, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'hv4-review-dot';
          button.setAttribute('aria-label', `${this.controls.dataset.label} ${index + 1}`);
          button.setAttribute('aria-controls', this.track.id);
          button.addEventListener('click', () => this.track.scrollTo({ left: position, behavior: 'smooth' }));
          this.controls.append(button);
        });
        this.update();
      }
      update() {
        if (!this.positions?.length) return;
        let active = 0;
        this.positions.forEach((position, index) => {
          if (Math.abs(this.track.scrollLeft - position) < Math.abs(this.track.scrollLeft - this.positions[active])) active = index;
        });
        [...this.controls.children].forEach((button, index) => button.setAttribute('aria-current', index === active ? 'true' : 'false'));
      }
      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.observer?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lullor-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lullor-product')) {
    customElements.define('lullor-product', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.addEventListener('click', (event) => this.handleClick(event));
        this.addEventListener('keydown', (event) => this.handleKeydown(event));
        this.addEventListener('change', (event) => this.handleChange(event));
        this.querySelectorAll('[data-pair-carousel]').forEach((carousel) => this.updatePairButton(carousel));
        window.addEventListener('resize', () => this.querySelectorAll('[data-pair-carousel]').forEach((carousel) => this.updatePairButton(carousel)));
        document.addEventListener('click', (event) => {
          if (!event.target.closest('.ll-feature-v4')) this.closeTooltips();
        });
      }

      handleClick(event) {
        const thumbnail = event.target.closest('.ll-thumbs-v4 [data-media-target]');
        if (thumbnail) this.selectThumbnail(thumbnail, false);

        const legacyThumbnail = event.target.closest('[data-image]');
        if (legacyThumbnail) {
          const image = this.querySelector('.ll-main-image img');
          if (!image) return;
          image.removeAttribute('srcset');
          image.src = legacyThumbnail.dataset.image;
          image.alt = legacyThumbnail.dataset.alt;
          this.querySelectorAll('[data-image]').forEach((item) => item.setAttribute('aria-pressed', String(item === legacyThumbnail)));
        }

        const info = event.target.closest('.ll-feature-v4__info');
        if (info) {
          const feature = info.closest('.ll-feature-v4');
          const willOpen = !feature.classList.contains('is-open');
          this.closeTooltips();
          feature.classList.toggle('is-open', willOpen);
          info.setAttribute('aria-expanded', String(willOpen));
        }

        const next = event.target.closest('[data-pair-next]');
        if (next) {
          const carousel = next.closest('[data-pair-carousel]');
          const track = carousel.querySelector('[data-pair-track]');
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          const target = track.scrollLeft >= maximum - 2 ? 0 : Math.min(maximum, track.scrollLeft + 198);
          track.scrollTo({ left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
      }

      handleChange(event) {
        const input = event.target;
        if (!input.matches('input[name="id"][type="radio"]')) return;
        const price = this.querySelector('[data-price]');
        const compare = this.querySelector('[data-compare]');
        const compareLabel = this.querySelector('[data-compare-label]');
        const discount = this.querySelector('[data-discount]');
        const add = this.querySelector('[data-add]');
        price.textContent = input.dataset.price;
        compare.textContent = input.dataset.compare;
        compare.hidden = !input.dataset.compare;
        if (compareLabel) compareLabel.hidden = !input.dataset.compare;
        const compareCents = Number(input.dataset.compareCents);
        const priceCents = Number(input.dataset.priceCents);
        if (discount) {
          discount.textContent = compareCents > priceCents ? `${Math.round((compareCents - priceCents) * 100 / compareCents)}% OFF` : '';
          discount.hidden = compareCents <= priceCents;
        }
        add.disabled = input.dataset.available !== 'true';
        add.textContent = add.disabled ? add.dataset.sold : add.dataset.label;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
      }

      selectThumbnail(button, focus) {
        this.setMedia(button.dataset.mediaTarget);
        button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        if (focus) button.focus();
      }

      setMedia(mediaId) {
        if (!mediaId) return;
        const gallery = this.querySelector('media-gallery');
        if (gallery) {
          const nativeMediaId = `${gallery.dataset.section}-${mediaId}`;
          if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(nativeMediaId, false);
          else gallery.querySelector(`[data-target="${nativeMediaId}"] button`)?.click();
          return;
        }
        this.querySelectorAll('[data-media-panel]').forEach((panel) => {
          const active = panel.dataset.mediaPanel === String(mediaId);
          panel.hidden = !active;
          if (!active) panel.querySelectorAll('video').forEach((video) => video.pause());
        });
        this.querySelectorAll('.ll-thumbs-v4 [data-media-target]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === String(mediaId))));
      }

      handleKeydown(event) {
        if (event.key === 'Escape') this.closeTooltips();
        const nativeThumbnail = event.target.closest('.ll-native-gallery-v4 .thumbnail-list button');
        const thumbnail = nativeThumbnail || event.target.closest('.ll-thumbs-v4 [data-media-target]');
        if (!thumbnail) return;
        const buttons = nativeThumbnail
          ? [...this.querySelectorAll('.ll-native-gallery-v4 .thumbnail-list button')]
          : [...this.querySelectorAll('.ll-thumbs-v4 [data-media-target]')];
        const current = buttons.indexOf(thumbnail);
        let next = current;
        if (event.key === 'ArrowRight') next = Math.min(current + 1, buttons.length - 1);
        if (event.key === 'ArrowLeft') next = Math.max(current - 1, 0);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        if (next !== current) {
          event.preventDefault();
          if (nativeThumbnail) {
            buttons[next].focus();
            buttons[next].click();
          } else {
            this.selectThumbnail(buttons[next], true);
          }
        }
      }

      closeTooltips() {
        this.querySelectorAll('.ll-feature-v4.is-open').forEach((feature) => feature.classList.remove('is-open'));
        this.querySelectorAll('.ll-feature-v4__info[aria-expanded="true"]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
      }

      updatePairButton(carousel) {
        const track = carousel.querySelector('[data-pair-track]');
        const button = carousel.querySelector('[data-pair-next]');
        button.hidden = track.scrollWidth <= track.clientWidth + 2;
      }
    });
  }

  if (!customElements.get('lullor-bundle')) {
    customElements.define('lullor-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.closest('form');
        this.variants = JSON.parse(this.querySelector('[data-bundle-variants]').textContent);
        this.variantInput = this.querySelector('[data-bundle-variant-id]');
        this.querySelector('[data-bundle-options]').hidden = false;
        this.form.addEventListener('submit', (event) => this.submitBundle(event));
        this.addEventListener('change', (event) => {
          const offer = event.target.closest('[data-offer]');
          if (offer && !event.target.matches('[name="lullor_bundle"]')) offer.querySelector('[name="lullor_bundle"]').checked = true;
          this.update();
        });
        this.update();
      }

      money(cents) {
        const currency = window.Shopify?.currency?.active || this.dataset.currency;
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
      }

      selectedVariant(offer) {
        const values = [];
        offer.querySelectorAll('[data-option-position]').forEach((control) => {
          const position = Number(control.dataset.optionPosition) - 1;
          if (control.matches('fieldset')) values[position] = control.querySelector('input:checked')?.value;
          else values[position] = control.value;
        });
        return this.variants.find((variant) => variant.options.every((option, index) => option === values[index])) || this.variants[0];
      }

      update() {
        this.isDuo = this.querySelector('[name="lullor_bundle"]:checked').value === '2';
        const activeOffer = this.querySelector(`[data-offer="${this.isDuo ? '2' : '1'}"]`);
        const variant = this.selectedVariant(activeOffer);
        const pillowPairRegular = Number(this.dataset.pillowPrice) * 2;
        const marketRate = Number(window.Shopify?.currency?.rate);
        const basePairDiscount = Number(this.dataset.basePairDiscount);
        const fallbackPairDiscount = Number(this.dataset.marketPairDiscount);
        const pillowPairDiscount = marketRate > 0 ? Math.round(basePairDiscount * marketRate) : fallbackPairDiscount;
        const pillowPairBundle = Math.max(0, pillowPairRegular - pillowPairDiscount);
        const regularTotal = variant.price + pillowPairRegular;
        const comforterBundlePrice = variant.price;
        const bundleTotal = variant.price + pillowPairBundle;
        this.variantInput.value = String(variant.id);
        this.variantInput.querySelectorAll('option').forEach((option) => {
          option.selected = option.value === String(variant.id);
        });
        this.querySelector('[data-single-total]').textContent = this.money(variant.price);
        this.querySelector('[data-single-unit]').textContent = this.money(variant.price);
        this.querySelector('[data-duo-original]').textContent = this.money(regularTotal);
        this.querySelector('[data-duo-total]').textContent = this.money(bundleTotal);
        this.querySelectorAll('[data-duo-saving]').forEach((saving) => { saving.textContent = this.money(regularTotal - bundleTotal); });
        this.querySelector('[data-duo-comforter-unit]').textContent = this.money(comforterBundlePrice);
        this.querySelector('[data-pillow-bundle-price]').textContent = this.money(pillowPairBundle);
        this.querySelector('[data-pillow-bundle-saving]').textContent = this.money(pillowPairRegular - pillowPairBundle);
        const add = this.querySelector('[data-bundle-add]');
        add.textContent = this.isDuo ? add.dataset.duoLabel : add.dataset.singleLabel;
        add.disabled = !variant.available || (this.isDuo && this.dataset.pillowAvailable !== 'true');

        const product = this.closest('lullor-product');
        product.querySelector('[data-price]').textContent = variant.money;
        const compare = product.querySelector('[data-compare]');
        const compareLabel = product.querySelector('[data-compare-label]');
        const discount = product.querySelector('[data-discount]');
        compare.textContent = variant.compareMoney;
        compare.hidden = !variant.compareMoney;
        if (compareLabel) compareLabel.hidden = !variant.compareMoney;
        if (discount) {
          discount.textContent = variant.compareCents > variant.price ? `${Math.round((variant.compareCents - variant.price) * 100 / variant.compareCents)}% OFF` : '';
          discount.hidden = variant.compareCents <= variant.price;
        }
        product.setMedia(variant.mediaId);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }

      async submitBundle(event) {
        event.preventDefault();
        if (this.busy) return;
        const error = this.querySelector('[data-bundle-error]');
        const add = this.querySelector('[data-bundle-add]');
        error.hidden = true;
        this.busy = true;
        add.disabled = true;
        add.setAttribute('aria-busy', 'true');
        let added = false;
        const root = window.Shopify?.routes?.root || '/';

        try {
          const activeOffer = this.querySelector(`[data-offer="${this.isDuo ? '2' : '1'}"]`);
          const selectedVariant = this.selectedVariant(activeOffer);
          if (!selectedVariant?.id) throw new Error(this.dataset.error);
          this.variantInput.value = String(selectedVariant.id);
          const items = [{ id: Number(selectedVariant.id), quantity: 1 }];
          if (this.isDuo) items.push({ id: Number(this.dataset.pillowId), quantity: 2 });
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || this.dataset.error);
          added = true;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'lullor-bundle', cart: result } }));

          if (this.isDuo) {
            const discount = await fetch(`${root}cart/update.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ discount: this.dataset.code })
            });
            if (!discount.ok) throw new Error(this.dataset.discountError);
          }
          window.location.href = `${root}cart`;
        } catch (exception) {
          error.textContent = added ? this.dataset.discountError : exception.message;
          error.hidden = false;
          if (added) {
            const link = document.createElement('a');
            link.href = `${root}cart`;
            link.textContent = this.dataset.viewBag;
            error.append(' ', link);
          } else {
            this.busy = false;
            this.update();
          }
        } finally {
          add.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lullor-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lullor-reviews'))customElements.define('lullor-reviews',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('click',e=>{const b=e.target.closest('[data-direction]');if(!b)return;const t=this.querySelector('.ll-review-track');t.scrollBy({left:Number(b.dataset.direction)*(t.querySelector('article').getBoundingClientRect().width+20),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nova-one-page"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nova-store')) {
  customElements.define('nova-store', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const sticky = this.querySelector('[data-sticky-add]');
      const mainAdd = this.querySelector('[data-main-add]');
      const stickyPrice = this.querySelector('[data-sticky-price]');
      const stickyBar = this.querySelector('.nm-sticky');
      const stickyLabel = this.querySelector('[data-sticky-label]');
      const packs = this.querySelector('[data-main-add]');
      this.updateStickyVisibility = () => {
        cancelAnimationFrame(this.stickyFrame);
        this.stickyFrame = requestAnimationFrame(() => {
          if (packs && stickyBar) stickyBar.hidden = packs.getBoundingClientRect().bottom > 0;
        });
      };
      window.addEventListener('scroll', this.updateStickyVisibility, {passive:true});
      window.addEventListener('resize', this.updateStickyVisibility);
      this.updateStickyVisibility();
      const crossedCurrency = this.dataset.crossCurrency === 'true';
      const storefrontRate = Number(window.Shopify?.currency?.rate);
      const rateMatchesCurrency = window.Shopify?.currency?.active === this.dataset.currency;
      const conversionReady = !crossedCurrency || (rateMatchesCurrency && Number.isFinite(storefrontRate) && storefrontRate > 0);
      const exchangeRate = crossedCurrency ? storefrontRate : 1;
      this.querySelectorAll('.nm-pack').forEach(pack => {
        const baseSaving = Number(pack.dataset.baseSaving || 0);
        pack.dataset.saving = conversionReady ? String(Math.round(baseSaving * exchangeRate)) : '0';
        pack.querySelectorAll('[data-market-fallback]').forEach(note=>note.hidden=conversionReady);
        pack.querySelectorAll('[data-regular],[data-saving-label]').forEach(label=>label.hidden=!conversionReady);
        pack.querySelectorAll('[data-conversion-note]').forEach(note=>note.hidden=!conversionReady);
      });
      const orderLabel = this.querySelector('[data-order-label]');
      if(orderLabel) orderLabel.textContent = conversionReady ? orderLabel.dataset.after : orderLabel.dataset.before;
      const activeForm = () => this.querySelector('.nm-pack[open] .nm-form') || this.querySelector('.nm-form');
      const money = cents => new Intl.NumberFormat(this.dataset.locale || 'en-GB', {style:'currency',currency:this.dataset.currency || 'GBP'}).format(cents / 100);
      const addonInputs = [...this.querySelectorAll('[data-addon]')];
      const syncSticky = () => {
        const form = activeForm();
        if (!sticky || !form) return;
        const button = form.querySelector('.nm-add');
        sticky.disabled = button.disabled || Boolean(this.adding);
        if (mainAdd) { mainAdd.disabled = sticky.disabled; mainAdd.textContent = button.textContent.replace(' ↗', ''); }
        stickyLabel.textContent = form.closest('.nm-pack').querySelector('.nm-pack-copy strong').childNodes[0].textContent.trim();
        sticky.textContent = button.textContent;
        const pack = form.closest('.nm-pack');
        const basePrice = pack.querySelector('[data-price]').textContent;
        const extras = [...form.querySelectorAll('[data-addon]:checked')].reduce((sum,input)=>sum+Number(input.dataset.cents),0);
        const maskTotal = Math.max(0, [...form.querySelectorAll('[data-mask-variant]')].reduce((sum,select)=>sum+Number(select.selectedOptions[0].dataset.cents),0)-Number(pack.dataset.saving || 0));
        stickyPrice.textContent = money(maskTotal + extras) + (!conversionReady && Number(pack.dataset.packCount) > 1 ? ' · ' + this.dataset.beforeSaving : '');
        const orderTotal = this.querySelector('[data-order-total]');
        orderTotal.hidden = extras === 0;
        this.querySelector('[data-order-amount]').textContent = money(maskTotal + extras);
        const mainPrice = this.querySelector('[data-main-price]');
        if (mainPrice) mainPrice.textContent = basePrice;
        const mainCaption = this.querySelector('.nb-main-price>span');
        if (mainCaption) mainCaption.textContent = form.closest('.nm-pack').querySelector('.nm-pack-copy strong').childNodes[0].textContent.trim() + (!conversionReady && Number(pack.dataset.packCount) > 1 ? ' · ' + this.dataset.beforeSaving : '');
      };
      addonInputs.forEach(input => input.addEventListener('change', () => {
        addonInputs.filter(other=>other.value===input.value).forEach(other=>other.checked=input.checked);
        syncSticky();
      }));
      sticky?.addEventListener('click', () => activeForm()?.requestSubmit());
      mainAdd?.addEventListener('click', () => activeForm()?.requestSubmit());
      this.querySelectorAll('.nm-pack').forEach(pack => {
        pack.querySelector('summary')?.addEventListener('click', event => {
          if (pack.open || this.adding) event.preventDefault();
        });
        pack.addEventListener('toggle', () => {
          if (pack.open) this.querySelectorAll('.nm-pack').forEach(other => { if (other !== pack) other.open = false; });
          syncSticky();
        });
      });
      this.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
        const image = this.querySelector('.nm-main-image');
        if (!image) return;
        image.src = button.dataset.image;
        image.removeAttribute('srcset');
        image.alt = button.dataset.alt;
        this.querySelectorAll('[data-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
      const reviewCards = [...this.querySelectorAll('.nb-review-list .nm-review-card')];
      const moreReviews = this.querySelector('[data-more-reviews]');
      let shownReviews = 3;
      const revealReviews = () => { reviewCards.forEach((card, i) => card.hidden = i >= shownReviews); moreReviews.hidden = shownReviews >= reviewCards.length; };
      moreReviews?.addEventListener('click', () => { shownReviews += 3; revealReviews(); });
      if (moreReviews) revealReviews();
      const reviewTrack = this.querySelector('.nm-review-track');
      if (reviewTrack) {
        const previous = this.querySelector('[data-review-direction="-1"]');
        const next = this.querySelector('[data-review-direction="1"]');
        const position = this.querySelector('[data-review-position]');
        const updateReviews = () => {
          const cards = [...reviewTrack.querySelectorAll('article')];
          if (!cards.length) return;
          const first = cards[0].offsetLeft;
          const index = cards.reduce((best, card, i) => Math.abs(card.offsetLeft - first - reviewTrack.scrollLeft) < Math.abs(cards[best].offsetLeft - first - reviewTrack.scrollLeft) ? i : best, 0);
          previous.disabled = reviewTrack.scrollLeft <= 2;
          next.disabled = reviewTrack.scrollLeft >= reviewTrack.scrollWidth - reviewTrack.clientWidth - 2;
          position.textContent = (index + 1) + ' / ' + cards.length;
        };
        const moveReviews = direction => {
          const card = reviewTrack.querySelector('article');
          if (card) reviewTrack.scrollBy({left:direction * (card.getBoundingClientRect().width + 20), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        };
        previous.addEventListener('click', () => moveReviews(-1));
        next.addEventListener('click', () => moveReviews(1));
        reviewTrack.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); moveReviews(event.key === 'ArrowLeft' ? -1 : 1); }
        });
        reviewTrack.addEventListener('scroll', updateReviews, {passive:true});
        this.reviewObserver = new ResizeObserver(updateReviews);
        this.reviewObserver.observe(reviewTrack);
        updateReviews();
      }
      this.querySelectorAll('.nm-form').forEach(form => {
        const selects = [...form.querySelectorAll('[data-mask-variant]')];
        const button = form.querySelector('.nm-add');
        const error = form.querySelector('.nm-error');
        const sync = () => {
          const options = selects.map(select => select.selectedOptions[0]);
          selects.forEach(select => {
            const option = select.selectedOptions[0];
            const photo = select.closest('.nm-design-row').querySelector('[data-design-photo]');
            photo.hidden = !option.dataset.designImage;
            if (option.dataset.designImage) { photo.src = option.dataset.designImage; photo.alt = option.dataset.design; }
          });
          const regular = options.reduce((sum, option) => sum + Number(option.dataset.cents), 0);
          const pack = form.closest('.nm-pack');
          const saving = Math.min(regular, Number(pack.dataset.saving || 0));
          const total = regular - saving;
          pack.querySelector('[data-price]').textContent = money(total);
          const regularLabel = pack.querySelector('[data-regular]');
          const savingLabel = pack.querySelector('[data-saving-amount]');
          if(regularLabel) regularLabel.textContent = money(regular);
          if(savingLabel) savingLabel.textContent = money(saving);
          button.disabled = options.some(option => option.dataset.available !== 'true');
          button.textContent = button.disabled ? this.dataset.sold : this.dataset.add + ' ↗';
          error.hidden = true;
          syncSticky();
        };
        selects.forEach(select => select.addEventListener('change', sync));
        sync();
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (this.adding || form.dataset.busy === 'true' || button.disabled || !form.reportValidity()) return;
          this.adding = true;
          this.setAttribute('aria-busy', 'true');
          form.dataset.busy = 'true';
          button.disabled = true;
          button.textContent = this.dataset.loading;
          syncSticky();
          error.hidden = true;
          const quantities = new Map();
          selects.forEach(select => quantities.set(select.value, (quantities.get(select.value) || 0) + 1));
          const items = [...quantities].map(([id, quantity]) => ({ id, quantity }));
          selects.forEach(select => select.disabled = true);
          addonInputs.forEach(input => input.disabled = true);
          try {
            const selectedAddons = [...form.querySelectorAll('[data-addon]:checked')];
            if (selectedAddons.length) {
              const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
              if (!cartResponse.ok) throw new Error(this.dataset.error);
              const currentCart = await cartResponse.json();
              selectedAddons.forEach(input => {
                if (!currentCart.items.some(item=>String(item.variant_id)===input.value)) items.push({id:input.value,quantity:1});
              });
            }
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || this.dataset.error);
            window.location.assign(this.dataset.cartUrl);
          } catch (failure) {
            sync();
            error.textContent = failure.message || this.dataset.error;
            error.hidden = false;
            error.focus();
          } finally {
            selects.forEach(select => select.disabled = false);
            addonInputs.forEach(input => input.disabled = input.dataset.inCart === "true");
            this.adding = false;
            this.removeAttribute('aria-busy');
            form.dataset.busy = 'false';
            syncSticky();
          }
        });
      });
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.updateStickyVisibility); window.removeEventListener('resize', this.updateStickyVisibility); cancelAnimationFrame(this.stickyFrame); this.reviewObserver?.disconnect(); this.initialized = false; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
